module.exports = __webpack_public_path__ + "static/media/21ECLAC35.31d342da.jpg";